import { theme } from '@vscom/components'
import { createTheme } from '@mui/material/styles'

export const appTheme = createTheme(theme)
